var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 399,
    viewBox: "0 0 397 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350.38 58.9531H52.2564C46.2843 58.9531 41.4199 63.8012 41.4199 69.8129V276.488H361.217V69.8129C361.217 63.8012 356.353 58.9531 350.38 58.9531Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349.994 63.5103H52.6408C48.9323 63.5103 45.9463 66.5161 45.9463 70.2491V273.434H356.689V70.2491C356.689 66.5161 353.703 63.5103 349.994 63.5103Z",
    fill: "#0E538C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1201 78.5396H345.515V266.21H57.1201V78.5396Z",
    fill: "#605B5B",
    fillOpacity: 0.81
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.956 71.946C202.956 72.8671 202.233 73.5943 201.318 73.5943C200.403 73.5943 199.681 72.8671 199.681 71.946C199.681 71.0248 200.403 70.2976 201.318 70.2976C202.233 70.3461 202.956 71.0733 202.956 71.946Z",
    fill: "#F6F6F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.29 88.9146H122.187V94.0536H93.29V88.9146Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1865 88.9146H79.0826V94.0536H67.1865V88.9146ZM67.1865 98.3199H79.0826V103.459H67.1865V98.3199ZM67.1865 109.471H79.0826V114.61H67.1865V109.471ZM67.1865 120.573H79.0826V125.712H67.1865V120.573ZM67.1865 131.723H79.0826V136.862H67.1865V131.723ZM67.1865 142.826H79.0826V147.965H67.1865V142.826ZM128.16 88.9146H225.11V94.0536H128.16V88.9146Z",
    fill: "#CCE9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.501 98.3198H132.398V103.459H103.501V98.3198Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.37 98.3198H235.321V103.459H138.37V98.3198Z",
    fill: "#CCE9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.55 109.47H149.447V114.609H120.55V109.47Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.42 109.47H252.37V114.609H155.42V109.47Z",
    fill: "#CCE9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.551 120.573H166.448V125.712H137.551V120.573Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.421 120.573H269.371V125.712H172.421V120.573Z",
    fill: "#CCE9FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.55 131.723H149.447V136.862H120.55V131.723Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.42 131.723H303.422V136.862H155.42V131.723Z",
    fill: "#CCE9FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.501 142.825H132.398V147.964H103.501V142.825Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M138.37 142.825H201.318V147.964H138.37V142.825Z",
    fill: "#CCE9FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.29 157.418H122.187V162.557H93.29V157.418Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.1865 157.418H79.0826V162.557H67.1865V157.418ZM67.1865 166.824H79.0826V171.963H67.1865V166.824ZM67.1865 177.974H79.0826V183.113H67.1865V177.974ZM67.1865 189.077H79.0826V194.216H67.1865V189.077ZM67.1865 200.227H79.0826V205.366H67.1865V200.227ZM67.1865 211.33H79.0826V216.469H67.1865V211.33ZM128.16 157.418H225.11V162.557H128.16V157.418Z",
    fill: "#CCE9FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.501 166.824H132.398V171.963H103.501V166.824Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.37 166.824H235.321V171.963H138.37V166.824Z",
    fill: "#CCE9FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.55 177.974H149.447V183.113H120.55V177.974Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.42 177.974H252.37V183.113H155.42V177.974Z",
    fill: "#CCE9FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.29 225.874H122.187V231.013H93.29V225.874Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.1865 225.874H79.0826V231.013H67.1865V225.874ZM67.1865 235.328H79.0826V240.467H67.1865V235.328ZM67.1865 246.43H79.0826V251.569H67.1865V246.43ZM128.16 225.874H225.11V231.013H128.16V225.874Z",
    fill: "#CCE9FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.501 235.328H132.398V240.467H103.501V235.328Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.37 235.328H235.321V240.467H138.37V235.328Z",
    fill: "#CCE9FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.55 246.43H149.447V251.569H120.55V246.43Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.42 246.43H252.37V251.569H155.42V246.43Z",
    fill: "#CCE9FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M137.551 189.076H166.448V194.215H137.551V189.076Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.421 189.076H320.423V194.215H172.421V189.076Z",
    fill: "#CCE9FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.55 200.227H149.447V205.366H120.55V200.227Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.42 200.227H252.37V205.366H155.42V200.227Z",
    fill: "#CCE9FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.501 211.329H132.398V216.468H103.501V211.329Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M138.37 211.329H235.321V216.468H138.37V211.329Z",
    fill: "#CCE9FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M382.456 272.803H20.1798C18.1088 272.803 16.375 274.5 16.375 276.633V281.579C16.375 283.663 18.0607 285.409 20.1798 285.409H382.504C384.575 285.409 386.309 283.712 386.309 281.579V276.633C386.261 274.5 384.575 272.803 382.456 272.803Z",
    fill: "#D3D3D3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M232.383 278.282H170.254C169.435 278.282 168.761 278.961 168.761 279.785C168.761 280.609 169.435 281.288 170.254 281.288H232.431C233.25 281.288 233.924 280.609 233.924 279.785C233.876 278.961 233.202 278.282 232.383 278.282Z",
    fill: "#F7F7F7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M283.483 327.248L283.435 335.053C283.435 335.053 284.398 340.047 285.217 345.38C285.987 350.713 286.613 356.385 285.795 357.694C284.205 360.312 281.075 357.694 280.545 355.076C280.015 352.458 279.245 336.12 279.245 336.12L278.715 325.599L283.483 327.248ZM291.381 326.181L290.177 333.211C290.177 333.211 287.817 352.409 289.118 355.318C290.418 358.227 294.608 356.918 294.368 352.943C294.127 349.016 295.138 335.053 295.138 335.053L297.498 326.617L291.381 326.181Z",
    fill: "#8C8C8C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M288.155 240.612L287.577 249.242L309.731 260.004C313.729 262.186 315.655 266.889 314.355 271.252L299.039 328.605L291.43 326.181L298.124 273.434C298.606 270.185 296.391 267.18 293.164 266.646L285.265 265.386L276.885 256.756L286.614 265.531C288.974 267.664 290.129 270.816 289.696 273.967L283.483 327.248L276.596 328.993L273.513 276.585C273.273 273.24 271.057 270.428 267.927 269.41L254.297 265.046C252.129 263.737 250.781 261.362 250.685 258.792L251.263 240.321L288.155 240.612Z",
    fill: "#8C8C8C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M249.817 259.956L253.478 188.301C253.478 188.301 268.601 187.38 273.128 187.38C275.584 187.38 279.774 188.543 283.097 189.61C286.228 190.628 288.781 190.531 290.322 193.44L315.125 241.339L299.858 242.794L294.753 236.976L297.353 233.049L288.058 211.038L289.888 251.035L249.817 259.956Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M288.395 202.312L304.867 232.225L299.762 238.285C299.762 238.285 297.691 238.721 295.716 238.043L294.801 236.976L297.402 233.049L288.106 211.039L288.395 202.312Z",
    fill: "#0F0F0F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M273.754 209.051C268.746 209.051 259.595 195.912 259.595 190.87C259.595 189.852 259.787 188.883 260.076 187.962C264.748 187.719 270.576 187.428 273.128 187.428C274.236 187.428 275.681 187.671 277.27 188.01C277.559 188.931 277.752 189.852 277.752 190.87C277.704 195.912 278.763 209.051 273.754 209.051Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M251.648 200.712L249.817 260.392L274.284 254.478L251.648 200.712Z",
    fill: "#0F0F0F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M274.62 180.059C274.187 180.932 271.201 192.664 271.201 192.664C271.201 192.664 270.141 194.603 267.589 194.361C265.036 194.167 263.977 190.531 263.977 190.531L268.456 175.793L274.62 180.059Z",
    fill: "#FCD2B1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M258.92 172.835C258.92 180.932 267.445 189.901 275.488 189.901C283.531 189.901 288.01 180.932 288.01 172.835C288.01 164.739 281.508 158.194 273.465 158.194C265.422 158.146 258.92 164.739 258.92 172.835Z",
    fill: "#FFBCC6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M276.431 190.278C285.357 188.813 291.413 180.342 289.958 171.357C288.503 162.372 280.088 156.276 271.162 157.74C262.236 159.205 256.18 167.676 257.635 176.661C259.09 185.646 267.505 191.743 276.431 190.278Z",
    fill: "#FFE3CA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M270.72 253.072C271.346 252.878 276.74 250.211 280.545 250.211C284.35 250.211 289.022 254.284 289.022 254.284C289.022 254.284 289.648 256.417 287.095 255.98C284.543 255.544 287.432 257.58 287.432 257.58C287.432 257.58 287.288 257.677 284.302 258.114C281.316 258.55 269.757 257.92 269.757 257.92L270.72 253.072Z",
    fill: "#FFE3CA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M253.478 188.349L251.407 235.473L270.672 253.023L269.757 257.968L242.642 243.375C240.041 241.97 238.548 239.061 238.933 236.103L243.894 200.033C244.279 195.525 247.024 191.549 251.022 189.561L253.478 188.349ZM268.746 261.992H317.775V258.356H268.746C267.734 258.356 266.964 259.18 266.964 260.15C266.915 261.168 267.734 261.992 268.746 261.992Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M282.183 261.992H329.478C331.549 261.992 333.379 260.586 333.957 258.55L342.289 226.892C343.06 223.935 340.844 221.074 337.81 221.074H296.535C294.464 221.074 292.634 222.48 292.056 224.516L282.183 261.992Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M282.183 261.992H329.478C331.549 261.992 333.379 260.586 333.957 258.55L342.289 226.892C343.06 223.935 340.844 221.074 337.81 221.074H296.535C294.464 221.074 292.634 222.48 292.056 224.516L282.183 261.992Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M310.02 244.345C309.49 246.43 310.79 248.078 312.909 248.078C315.029 248.078 317.148 246.381 317.677 244.345C318.207 242.26 316.907 240.612 314.788 240.612C312.669 240.564 310.549 242.26 310.02 244.345Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M273.802 157.515C282.231 157.515 289.118 163.915 290.081 172.108C287.239 174.241 283.531 175.163 280.015 174.581C275.873 173.854 272.165 170.993 270.431 167.163C270.575 169.005 270.672 170.848 270.383 172.642C270.094 174.435 269.323 176.229 267.878 177.393C267.782 176.132 267.637 174.775 267.011 173.66C266.337 172.545 264.94 171.769 263.784 172.254C262.918 172.593 262.388 173.466 262.243 174.387C262.099 175.308 262.34 176.229 262.677 177.102C263.207 178.459 263.977 179.72 264.94 180.738C263.014 181.029 260.943 181.271 259.016 181.077C258.005 178.896 257.379 176.52 257.379 173.95C257.379 164.885 264.748 157.515 273.802 157.515Z",
    fill: "#2A94F4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M259.69 176.714C259.69 179.477 261.906 181.707 264.651 181.707C267.396 181.707 269.612 179.477 269.612 176.714C269.612 173.95 267.396 171.72 264.651 171.72C261.954 171.72 259.69 173.95 259.69 176.714ZM291.381 326.181L290.514 331.466L295.716 333.114L297.161 327.927L291.381 326.181ZM283.434 333.114L279.1 333.938L278.859 328.411L283.483 327.248L283.434 333.114Z",
    fill: "#FFE3CA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M264.652 165.127C268.695 165.127 271.972 161.828 271.972 157.758C271.972 153.688 268.695 150.389 264.652 150.389C260.609 150.389 257.331 153.688 257.331 157.758C257.331 161.828 260.609 165.127 264.652 165.127Z",
    fill: "#2A94F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/header-img.69340944bbc834333ad23728f598aa84.svg";
export { ForwardRef as ReactComponent };